import React, { Component } from "react";
import { Link, useParams } from "react-router-dom";
import { ProSidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import 'react-pro-sidebar/dist/css/styles.css';
import { connect } from 'react-redux';

class AdminSidebar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isActive: false,
            isActiveHub: false,
            currPath: '',
            users: [
                { routeName: "Access Management", linkTo: "/access-management" },
                { routeName: "User Management", linkTo: "/user-management" },
            ],
            communityHub: [
                { routeName: "Village Home Page", linkTo: "/villege-home-page" },
                { routeName: "MS Partners", linkTo: "/partners-view" },
                { routeName: 'MS Partner Home Page', linkTo: '/ms-partner-page' },
                { routeName: "Community Hub", linkTo: "/satellites-view" },
                { routeName: 'Community Hub Home Page', linkTo: '/satellite-page' },
            ],
            communityHubReference: [{ routeName: 'Interests', linkTo: '/Community-Interests' }],
            fpgRouter: [
                { routeName: "Catalog", linkTo: "/filmlist" },
                { routeName: "Shorts Program", linkTo: "/short-program-list" },
            ],
            referenceValues: [
                { routeName: "Category", linkTo: "/filmcategory" },
                { routeName: "Award Category", linkTo: "/awardcategory" },
                { routeName: "Genre & Type", linkTo: "/filmgenre" },
                { routeName: "Interest Tracks", linkTo: "/filminterest" },
                { routeName: "Accessibility", linkTo: "/filmaccessibillity" },
                { routeName: "Credit Label", linkTo: "/filmcreditlebel" },
                { routeName: "Devices", linkTo: "/newfrontierdevice" },
                { routeName: "Screening Types", linkTo: "/screeningtype" },
            ],
            productscoupons: [
                { routeName: "Products", linkTo: "/product-list" },
                { routeName: "Discounts", linkTo: "/discounts-list" },
            ],
            ticketing: [
                { routeName: "Ticketing", linkTo: "/ticketing" },
                { routeName: "Benefits", linkTo: "/benefits" },
            ],
            emailTemplateList: [
                { routeName: "Email Template", linkTo: "/email-list" },
            ],
            WaitlistList: [
                { routeName: "My Waitlists", linkTo: "/my-waitlists" },
                { routeName: "Waitlists", linkTo: "/waitlist-management" },
            ],
            festivalHome: [
                { routeName: "Festival Dates", linkTo: "/Header-footer-date" },
                { routeName: "Festival Website", linkTo: "/home" },
                { routeName: "Email Template", linkTo: "/email-list" },
                { routeName: "Highlights", linkTo: "/highlights" },
            ],
            htfRouterInPerson: [
                { routeName: "Header", linkTo: "/fest-header-inPerson" },
                { routeName: "Tickets", linkTo: "/fest-tickets" },
                { routeName: "Getting Around", linkTo: "/fest-getting-around" },
                { routeName: "Venues", linkTo: "/venue" },
                { routeName: "Festival Stores", linkTo: "/festival-store" },
                { routeName: "Accessibility", linkTo: "/accessibility-inPerson" },
                { routeName: "COVID-19", linkTo: "/COVID-19" },
                { routeName: "Safety & Belonging", linkTo: "/safety-belonging-inPerson" },
                { routeName: "FAQ", linkTo: "/FAQ-inPerson" },
            ],
            htfRouterOnline: [
                { routeName: "Header", linkTo: "/fest-header-online" },
                { routeName: "Tickets", linkTo: "/tickets-redemptions" },
                { routeName: "How to Watch", linkTo: "/watch" },
                { routeName: "Check Your Tech", linkTo: "/check-your-tech" },
                { routeName: "Accessibility", linkTo: "/accessibility-online" },
                { routeName: "Safety & Belonging", linkTo: "/safety-belonging-online" },
                { routeName: "FAQ", linkTo: "/FAQ-online" },
            ],

            // PAF Start
            PostAcceptanceForm: [
                { routeName: "Projects", linkTo: "/paf-projectlist" },
            ],
            PafReferenceValues: [
                { routeName: "Credit Label", linkTo: "/project-film-credit-label" },
                { routeName: "Category", linkTo: "/project-film-category" },
            ],
            // PAF End
            locations: [
                { routeName: "Locations", linkTo: "/locations" },
                { routeName: "Landing Page", linkTo: "/Landing-Page" },

            ],
            referenceType: [
                { routeName: "Venue Type", linkTo: "/venue-type" },
                { routeName: "Location Accessibility", linkTo: "/location-accessibility" },
                { routeName: "Amenities", linkTo: "/amenities" },
            ],
            other: [
                { routeName: "Store Upsell Products", linkTo: "/store-listupsell-product" },
                { routeName: "Membership List", linkTo: "/member-list" },
                { routeName: "Fest Time Home", linkTo: "/fest-time-home" }
            ],
            accessControlledPages: [
                { routeName: "Access Controlled Pages", linkTo: "/access-controlled-pages" },
            ],
        };
    }
    componentDidMount() {
        if (this.props.getBackToAdminPreviousPath === 'privateScreeningPartner') {
            this.setState({ currPath: '/partners-list' })
            this.setState({ open: true })
        } else {
            this.setState({ currPath: this.props.router.pathname })
        }
    }
    changeRouter = (e) => {
        this.setState({ currPath: e })
    }
    checkSingleScroll = (item) => {
        let errorFlag = false;
        const { classList } = item.target.parentElement.parentElement.parentElement.parentElement.parentElement
        let ClassData = classList.contains('pro-menu')
        if (ClassData) return errorFlag
        else return !errorFlag
    }

    onToggle = (item) => {
        let eleOffset = item.target.closest('.pro-menu-item').offsetTop;
        if (item.target.innerText === "Reference Values" || item.target.tagName === 'A' && this.checkSingleScroll(item)) {
        }
        else {
            setTimeout(() => {
                document.getElementsByClassName('pro-sidebar-layout')[0].scrollTo({
                    top: eleOffset,
                    behavior: 'smooth'
                })
            }, 200)
        }
    }

    render() {
        // const currPath = this.props.router.pathname;
        const currPath = (this.props.router.pathname === '/admin-dashboard' || this.props.router.pathname === '/') ? '/access-management' : this.props.router.pathname;
        const otherDefault = ['/', '/access-management', '/user-management', '/product-list', '/discounts-list', '/ticketing', '/admin-dashboard', '/home', '/highlights', '/filmlist', '/film', '/Header-footer-date',
            '/create-film', '/short-program-list', '/program-view', '/program', '/private-events-list', '/add-private-events',
            '/filmcategory', '/eventcategory', '/othereventscategory', '/newfrontiercategory', '/awardcategory', '/screeningtype', '/filmgenre', '/filminterest', '/filmaccessibillity', '/eventsaccessiblity', '/othereventsaccessiblity', '/newfrontieraccessiblity',
            '/filmcreditlebel', '/new-frontier-creditlebel', '/fest-header-inPerson', '/fest-getting-around', '/venue', '/fest-tickets', '/festival-store', '/accessibility-inPerson', '/COVID-19', '/safety-belonging-inPerson', '/FAQ-inPerson', '/tickets-redemptions', '/watch', '/check-your-tech',
            '/fest-header-online', '/accessibility-online', '/health-wellness-online', '/safety-belonging-online', '/FAQ-online', '/screening', '/about-sundance', '/festival-help', '/add-sponsors', '/mobile-app',
            '/page-takeover-list', '/create-page-takeover', '/page-takeover-view', '/access-controlled-pages', '/access-controlled-pages/create', '/eventsgenre'
        ]

        return (
            <div className="left_side_wrapper toggle_sidebar_wrapper ">
                <ProSidebar >
                    <Menu active={true} onClick={(e) => this.onToggle(e)}>

                        {/* Users */}
                        <SubMenu title="Users" defaultOpen={['/access-management', '/user-management'].includes(currPath) ? true : false} >
                            {
                                this.state.users.map((item) => {
                                    return (
                                        <MenuItem key={item.linkTo} active={item.linkTo === currPath ? true : false} >
                                            <Link onClick={this.changeRouter.bind(this, item.linkTo)} to={item.linkTo} >{item.routeName}</Link>
                                        </MenuItem>
                                    )
                                })
                            }
                        </SubMenu>

                        {/* Festival Program Guide */}
                        <SubMenu title="Festival Program Guide" defaultOpen={['/filmlist', '/create-film', '/film', '/short-program-list', '/program', '/program-view', '/filmcategory', '/eventcategory', '/othereventscategory', '/filmgenre', '/filminterest', '/filmaccessibillity', '/filmcreditlebel', "/awardcategory", "/screenigtype", "/screeningtype", '/eventsgenre'].includes(currPath) ? true : false}>
                            {
                                this.state.fpgRouter.map((item) => {
                                    return (
                                        <MenuItem key={item.linkTo} active={item.linkTo === currPath ? true : false}>
                                            <Link onClick={this.changeRouter.bind(this, item.linkTo)} to={item.linkTo} >{item.routeName}</Link>
                                        </MenuItem>
                                    )
                                })
                            }

                            <SubMenu title="Reference Values" defaultOpen={['/filmcategory', '/eventcategory', '/othereventscategory', '/filmgenre', '/filminterest', '/filmaccessibillity', '/filmcreditlebel', '/awardcategory', '/screeningtype', '/eventsgenre'].includes(currPath) ? true : false}>
                                {
                                    this.state.referenceValues.map((item) => {
                                        return (
                                            <MenuItem key={item.linkTo} active={item.linkTo === currPath ? true : false}>
                                                <Link onClick={this.changeRouter.bind(this, item.linkTo)} to={item.linkTo} >{item.routeName}</Link>
                                            </MenuItem>
                                        )
                                    })
                                }
                            </SubMenu>
                        </SubMenu>

                        {/* Post-Acceptance Form */}
                        <SubMenu title="Post-Acceptance Form" defaultOpen={['/paf-projectlist', '/paf-project'].includes(currPath) ? true : false}>
                            {
                                this.state.PostAcceptanceForm.map((item) => {
                                    return (
                                        <MenuItem key={item.linkTo} active={item.linkTo === currPath ? true : false}>
                                            <Link onClick={this.changeRouter.bind(this, item.linkTo)} to={item.linkTo} >{item.routeName}</Link>
                                        </MenuItem>
                                    )
                                })
                            }
                        </SubMenu>

                        {/* Ticketing */}
                        <SubMenu title="Ticketing" defaultOpen={['/ticketing', '/benefits'].includes(currPath) ? true : false}>
                            {
                                this.state.ticketing.map((item) => {
                                    return (
                                        <MenuItem key={item.linkTo} active={item.linkTo === currPath ? true : false}>
                                            <Link onClick={this.changeRouter.bind(this, item.linkTo)} to={item.linkTo} >{item.routeName}</Link>
                                        </MenuItem>
                                    )
                                })
                            }
                        </SubMenu>

                        {/* Locations */}
                        <SubMenu title="Locations" defaultOpen={['/locations', '/create-location', '/location', '/Landing-Page', '/venue-type', '/location-accessibility', '/amenities'].includes(currPath) ? true : false}>
                            {
                                this.state.locations.map((item) => {
                                    // debugger
                                    return (
                                        <MenuItem key={item.linkTo} active={item.linkTo === currPath ? true : false}>
                                            <Link onClick={this.changeRouter.bind(this, item.linkTo)} to={item.linkTo} >{item.routeName}</Link>
                                        </MenuItem>
                                    )
                                })
                            }
                            <SubMenu title="Reference Values" defaultOpen={['/venue-type', '/location-accessibility', '/amenities'].includes(currPath) ? true : false}>
                                {
                                    this.state.referenceType.map((item) => {
                                        return (
                                            <MenuItem key={item.linkTo} active={item.linkTo === currPath ? true : false}>
                                                <Link onClick={this.changeRouter.bind(this, item.linkTo)} to={item.linkTo} >{item.routeName}</Link>
                                            </MenuItem>
                                        )
                                    })
                                }
                            </SubMenu>
                        </SubMenu>

                        {/* Products & Discounts */}
                        <SubMenu title="Products & Discounts" defaultOpen={['/product-list', '/product-detail', '/discounts-list', '/discount-detail', '/store-listupsell-product', '/product-store-detail', '/member-list', '/member-detail'].includes(currPath) ? true : false}>
                            {
                                this.state.productscoupons.map((item) => {
                                    return (
                                        <MenuItem key={item.linkTo} active={item.linkTo === currPath ? true : false}>
                                            <Link onClick={this.changeRouter.bind(this, item.linkTo)} to={item.linkTo} >{item.routeName}</Link>
                                        </MenuItem>
                                    )
                                })
                            }
                        </SubMenu>

                        {/* Sponsors */}
                        <MenuItem active={'/add-sponsors' === currPath ? true : false}>
                            <Link onClick={this.changeRouter.bind(this, '/add-sponsors')} to='/add-sponsors' >Sponsors</Link>
                        </MenuItem>

                        {/* Waitlist Management */}
                        <SubMenu title="Waitlist Mangement" defaultOpen={['/my-waitlists', '/waitlist-management', '/waitlist-detail'].includes(currPath) ? true : false}>
                            {
                                this.state.WaitlistList.map((item) => {
                                    return (
                                        <MenuItem key={item.linkTo} active={item.linkTo === currPath ? true : false}>
                                            <Link onClick={this.changeRouter.bind(this, item.linkTo)} to={item.linkTo} >{item.routeName}</Link>
                                        </MenuItem>
                                    )
                                })
                            }
                        </SubMenu>

                        {/* Configuration */}
                        <SubMenu title="Configuration" defaultOpen={['/home', '/Header-footer-date', '/highlights', '/fest-time-home', '/create-highlight', '/highlight-detail-view', '/email-list', '/email-detail', '/page-takeover-list', '/archives-page'].includes(currPath) || currPath.startsWith('/page-takeover') || currPath.startsWith('/create-page-takeover') ? true : false}>
                            {this.state.festivalHome.map((item) => (
                                <MenuItem key={item.linkTo} active={item.linkTo === currPath ? true : false}>
                                    <Link onClick={this.changeRouter.bind(this, item.linkTo)} to={item.linkTo} >{item.routeName}</Link>
                                </MenuItem>
                            ))}
                            <MenuItem active={'/page-takeover-list' === currPath || currPath.startsWith('/page-takeover') || currPath.startsWith('/create-page-takeover') ? true : false}>
                                <Link onClick={this.changeRouter.bind(this, '/page-takeover-list')} to="/page-takeover-list">Page Takeover</Link>
                            </MenuItem>
                            <MenuItem active={currPath === '/archives-page'}>
                                <Link onClick={this.changeRouter.bind(this, '/archives-page')} to="/archives-page">Archives Page</Link>
                            </MenuItem>
                        </SubMenu>

                        {/* Access Controlled Pages */}
                        <SubMenu title="Access Controlled Pages" defaultOpen={['/access-controlled-pages', '/access-controlled-pages/create'].some(p => currPath.startsWith(p))}>
                            {this.state.accessControlledPages.map((item) => (
                                <MenuItem active={item.linkTo === currPath} key={item.linkTo}>
                                    <Link onClick={this.changeRouter.bind(this, item.linkTo)} to={item.linkTo}>
                                        {item.routeName}
                                    </Link>
                                </MenuItem>
                            ))}
                        </SubMenu>

                        {/* =====================| Archived Label |===================== */}
                        <li class="archived_label">
                            <span class="archived">Archived</span>
                        </li>

                        {/* Festival Village */}
                        <SubMenu title="Festival Village" defaultOpen={['/partners-view', '/satellites-view', '/partner-adminview', '/profile-partner-view', '/profile-satellite-view', '/satellite-adminview'].includes(currPath) ? true : false}>
                            {this.state.communityHub.map((item) => (
                                <MenuItem key={item.linkTo} active={item.linkTo === currPath ? true : false}>
                                    <Link onClick={this.changeRouter.bind(this, item.linkTo)} to={item.linkTo} >{item.routeName}</Link>
                                </MenuItem>
                            ))}
                            <SubMenu title="Reference Values">{this.state.communityHubReference.map((item) => (
                                <MenuItem key={item.linkTo} active={item.linkTo === currPath ? true : false}>
                                    <Link onClick={this.changeRouter.bind(this, item.linkTo)} to={item.linkTo} >{item.routeName}</Link>
                                </MenuItem>
                            ))}</SubMenu>
                        </SubMenu>

                        {/* How To Fest - In-Person */}
                        <SubMenu title=" How To Fest - In-Person" defaultOpen={['/fest-header-inPerson', '/fest-getting-around', '/venue', '/fest-tickets', '/festival-store', '/accessibility-inPerson', '/COVID-19', '/safety-belonging-inPerson', '/FAQ-inPerson'].includes(currPath) ? true : false}>
                            {
                                this.state.htfRouterInPerson.map((item) => {
                                    return (
                                        <MenuItem key={item.linkTo} active={item.linkTo === currPath ? true : false}>
                                            <Link onClick={this.changeRouter.bind(this, item.linkTo)} to={item.linkTo} >{item.routeName}</Link>

                                        </MenuItem>
                                    )
                                })
                            }
                        </SubMenu>

                        {/* How To Fest - Online */}
                        <SubMenu title=" How To Fest - Online" defaultOpen={['/tickets-redemptions', '/watch', '/check-your-tech', '/fest-header-online', '/accessibility-online', '/health-wellness-online', '/safety-belonging-online', '/FAQ-online'].includes(currPath) ? true : false}>
                            {
                                this.state.htfRouterOnline.map((item) => {
                                    return (
                                        <MenuItem key={item.linkTo} active={item.linkTo === currPath ? true : false}>
                                            <Link onClick={this.changeRouter.bind(this, item.linkTo)} to={item.linkTo} >{item.routeName}</Link>

                                        </MenuItem>
                                    )
                                })
                            }
                        </SubMenu>

                        {/* Private Screening */}
                        <SubMenu title="Private Screening" defaultOpen={['/partners-list', '/partners-film-view'].includes(currPath) ? true : false}>
                            {
                                <>
                                    <MenuItem active={'/partners-list' === currPath ? true : false}>
                                        <Link onClick={this.changeRouter.bind(this, '/partners-list')} to='/partners-list' >Private Screening Partners</Link>
                                    </MenuItem>
                                </>
                            }
                        </SubMenu>

                        {/* Mobile App Notifications */}
                        <MenuItem active={'/mobile-app' === currPath ? true : false} >
                            <Link onClick={this.changeRouter.bind(this, '/mobile-app')} to="/mobile-app">Mobile app Notifications</Link>
                        </MenuItem>

                        {/* Other */}
                        <SubMenu title="Other" defaultOpen={['/highlights', '/member-list','/fest-time-home'].includes(currPath) ? true : false}>
                            {this.state.other.map((item) => (
                                <MenuItem active={item.linkTo === currPath ? true : false}>
                                    <Link onClick={this.changeRouter.bind(this, item.linkTo)} to={item.linkTo} >{item.routeName}</Link>
                                </MenuItem>
                            ))}
                            {/* Screening */}
                            <MenuItem active={'/screening' === currPath ? true : false}  >
                                <Link onClick={this.changeRouter.bind(this, '/screening')} to="screening">Screening</Link>
                            </MenuItem>

                            {/* Festival Help */}
                            <MenuItem active={'/festival-help' === currPath ? true : false} >
                                <Link onClick={this.changeRouter.bind(this, '/festival-help')} to="/festival-help">Festival Help</Link>
                            </MenuItem>
                        </SubMenu>
                    </Menu>
                </ProSidebar>
            </div>
        );
    }
}
const mapStateToProps = state => ({
    getLoginRole: state.getLoginRole,
});

//export default AdminSidebar
export default connect(mapStateToProps)(AdminSidebar);